import {override} from "mobx";
import {StatusDateGameCardViewModel} from "../../../../../core/components/game-card/view-models/status-date.game-card.view-model";
import {PartialGameDomainModel} from "../../../../../domain/partial-game/models/partial-game-domain-model";
import {AthleteNextGameModuleTerms} from "../athlete-next-game.module.terms";
import {ODDS_TYPES} from "../../../../../core/components/odds/components/odds-consts";
import {DatetimeUtils} from "../../../../../infrastructure/utils/datetime-utils";
import {LIGHT_PALETTE, COLORS} from "../../../../../core/app/consts/colors";

export class AthleteNextGameCardViewModel extends StatusDateGameCardViewModel {
  athleteNotInSquad: Boolean;

  constructor(partialGameDomainModel: PartialGameDomainModel, terms: AthleteNextGameModuleTerms, isSmallView: Boolean, date, time, oddsType: ODDS_TYPES, athleteNotInSquad, datetimeUtils: DatetimeUtils) {
    super(partialGameDomainModel, terms, isSmallView, date, time, oddsType);

    this.athleteNotInSquad = athleteNotInSquad;
    this.datetimeUtils = datetimeUtils;
  }

  @override get status(): String {
    const status: String = this.isEnded ? this.statusGameDate : super.status;

    return status;
  }

  get description(): String {
    const description: String = this.athleteNotInSquad ? (this.terms.WEB_ATHLETE_NEXT_GAME_NOT_IN_THE_SQUAD).addColorToSubString(LIGHT_PALETTE[COLORS.warningPrimary]) : null;

    return description;
  }

  get statusGameDate(): String {
    let gameTimeText;
    const showToday: Boolean = this.daysLeft === 0;
    const showTomorrow: Boolean = this.daysLeft === 1;

    if (showToday)
      gameTimeText = this.terms.WEB_MY_SCORES_TODAY_BUTTON
    else if (showTomorrow) {
      gameTimeText = this.terms.GAME_TIME_TOMORROW
    } else {
      gameTimeText = this.date;
    }

    return gameTimeText;
  }
}
